var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusinessConfidence(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8_12352)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.08933 4.66667C2.08933 2.82533 3.58133 1.33333 5.42267 1.33333C7.264 1.33333 8.756 2.82533 8.756 4.66667C8.756 6.508 7.264 8 5.42267 8C3.58133 8 2.08933 6.508 2.08933 4.66667ZM4.08933 22.6667V26.6667L2.75867 32H0L1.46533 26.156L1.44133 22.6667H1.42267V13.3333C1.42267 11.128 3.21733 9.33333 5.42267 9.33333H12.2493L16.3813 5.52C17.428 2.32 20.4373 0 23.9827 0C28.3947 0 31.9827 3.588 31.9827 8C31.9827 12.412 28.3947 16 23.9827 16C20.048 16 16.776 13.1427 16.1133 9.396L13.292 12H9.424V20H14.7573V24.9693L12.0907 26.82V22.668L4.08933 22.6667ZM18.648 8C18.648 10.9413 21.04 13.3333 23.9813 13.3333C26.9227 13.3333 29.3147 10.9413 29.3147 8C29.3147 5.05867 26.9227 2.66667 23.9813 2.66667C21.04 2.66667 18.648 5.05867 18.648 8ZM6.75467 12H5.42133C4.68533 12 4.088 12.5973 4.088 13.3333V20H6.75467V12ZM9.3 32H13.656L32.0893 19.2093V16.1867L9.3 32Z",
    fill: "#543C7D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8_12352"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessConfidence);
export default __webpack_public_path__ + "static/media/business-confidence.402bf9054480fa6448a8571ecd67bf91.svg";
export { ForwardRef as ReactComponent };